import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { DraftDetailsScreen } from '@/screens/insights-hub/draft-details-screen';
import { INSIGHTS_HUB_ROUTES } from './routes';
import { InsightsHubScreen } from '@/screens/insights-hub/insights-hub-screen';
import { InsightsHubStackParams } from './types';
import { InvoiceDetailV2Screen } from '@/screens/orders/invoice-detail-v2-screen';
import { OrderDetailV2Screen } from '@/screens/orders/order-detail-v2-screen';
import { OrderManagementScreen } from '@/screens/insights-hub/order-management-screen';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

const Stack = createStackNavigator<InsightsHubStackParams>();

export const InsightsHubStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={options}>
      <Stack.Screen
        component={InsightsHubScreen}
        name={INSIGHTS_HUB_ROUTES.Base}
      />
      <Stack.Screen
        component={DraftDetailsScreen}
        name={INSIGHTS_HUB_ROUTES.DraftDetails}
      />
      <Stack.Screen
        component={OrderDetailV2Screen}
        name={INSIGHTS_HUB_ROUTES.OrderDetails}
      />
      <Stack.Screen
        component={InvoiceDetailV2Screen}
        name={INSIGHTS_HUB_ROUTES.InvoiceDetails}
      />
      <Stack.Screen
        component={OrderManagementScreen}
        name={INSIGHTS_HUB_ROUTES.OrderManagement}
      />
    </Stack.Navigator>
  );
};
